export const ja = {
  language: '言語',
  search: '検索',
  mode: 'モード',
  displayModes: 'モード一覧を表示',
  userInput: 'ユーザー入力',
  teacherLabel: '先生用',
  searchModes: 'モードを検索',
  start: 'はじめる',
  restartConversation: '会話をやり直す',
  tapToReply: 'タップして返信をかく',
  wordCount: '文字',
  imageToText: '画像 ▷ 文字',
  printChat: 'チャットを印刷',
  submitChat: 'チャットを提出',
  submitRecord: '記録提出(試験運用中)',
  home: 'ホーム',
  studentGuide: '生徒用ガイド',
  myPage: 'マイページ',
  manageModes: 'モード管理',
  confirmationForUsage: '使い方を確認したので',
  startChat: 'スタート'
}
